// extracted by mini-css-extract-plugin
module.exports = {"bio":"ForgotPasswordForm_bio__3V22r","forgot":"ForgotPasswordForm_forgot__2EDXv","forgotSpan":"ForgotPasswordForm_forgotSpan__wPHl7"};